import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {Question} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-general-seven',
    templateUrl: './vaps-general-seven.component.html',
    styleUrls: ['./vaps-general-seven.component.scss'],
    standalone: false
})
export class VapsGeneralSevenComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: Question;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();
  maskOptions: NgxCurrencyConfig;
  vap = {
    description1: '',
    description2: [],
    session_item_id: '1',
    amount: 0,
    selectedOption: ''
  };

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.getProductDetails();
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.currentVap?.value_max,
      min: this.currentVap?.value_min,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  getProductDetails(): any {
    const item = this.collation_vaps.find(col => col.product_vaps_id === this.productId && col.select === 1);
    if (item) {
      this.vap.description1 = item?.detail.substring(0, item?.detail.indexOf('|'));
      this.vap.description2 = item?.detail.substring(item?.detail.indexOf('|') + 1, item?.detail.length).split('_');
      this.vap.session_item_id = item.session_item_id ? item.session_item_id : '1';
      this.vap.amount = item.benefit_value ? item.benefit_value : 0;
      this.vap.selectedOption = item.option_id.toString();
    }
  }

  calculate(): void {
    this.onChange(1);
  }

  selectChange(value: Question): void {
    this.vap.selectedOption = value?.answer;
    this.onChange(0);
  }

  onChange(action: number): void {
    if (this.vap?.selectedOption && this.vap?.amount) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vap?.selectedOption + '|' + this.vap?.amount.toString();
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vap?.session_item_id, answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vap?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  let amount = 0;
                  p?.forEach(item => {
                    if (this.vap.session_item_id === item?.session_item_id) {
                      amount += +item?.premium;
                    }
                  });
                  this.amountChanged.emit(amount);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.amountChanged.emit(0);
    }
  }
}
